module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.a3309d4.ttf";